import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import Box from 'components/shared/Box'
interface CustomBoxProps {
    maxWidth?: number
}
interface OpeningHoursProps {
    isClosed: boolean
}

export const OpeningHoursWrapper = styled(Box)<OpeningHoursProps>`
    background-color: transparent;
    position: relative;
    z-index: 0;
    width: calc(100% + 24px);
    padding: 0 12px;
    margin-left: -12px;
    margin-right: -12px;
    overflow: hidden;
    height: ${({ isClosed }) => (isClosed ? 0 : 'auto')};
`

export const CustomBox = styled(Box)<CustomBoxProps>`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media ${respondAbove.md} {
        display: grid;
        overflow: visible;
        grid-template-columns: 200px repeat(4, minmax(120px, 200px));
        gap: 0 10px;
    }
    @media ${respondAbove.lg} {
        grid-template-columns: 270px repeat(4, minmax(120px, 200px));
        gap: 0 30px;
    }
    @media ${respondAbove.xl} {
        grid-template-columns: 276px repeat(4, minmax(120px, 200px));
        gap: 0 70px;
    }
`
export const ZonesWrapper = styled(Box)`
    align-self: flex-start;

    @media ${respondAbove.md} {
        align-self: flex-end;
    }
`

export const ColumnWrapper = styled(Box)`
    margin-top: 44px;

    @media ${respondAbove.md} {
        margin-top: 0;
    }
`
